import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { ClientMeasure } from "../domain/Demetra/client-measure";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root',
})
export class ClientMeasureService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/clientMeasure`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }
    
    getOrderableList(interventionCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${interventionCode}/orderable`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getOrderableList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ClientMeasure[]) => {
                return response.map((item: ClientMeasure) => {
                    return ClientMeasure.mapFromJSON(item);
                });
            }));
    }
}
